export default __webpack_public_path__ + "static/media/free_go.69abaf2e.jpg";